/* global functions */

function initSmoothScroll() {
	$('.smoothscroll').each(function () {
		let div = $(this).find('div').first().find('div').first();
		let width = 0;
		let margin = 30;
		if ($(this).hasClass('dcsection3__servicetabs')) {
			margin = 0;
		}

		div.children().each(function () {
			width = width + $(this).outerWidth(true) + margin;
		});
		div.css('width', width);
	});
}

var waitForFinalEvent = (function () {
	var timers = {};
	return function (callback, ms, uniqueId) {
		if (!uniqueId) {
			uniqueId = "Don't call this twice without a uniqueId";
		}
		if (timers[uniqueId]) {
			clearTimeout(timers[uniqueId]);
		}
		timers[uniqueId] = setTimeout(callback, ms);
	};
})();

function initResizeEvents() {
	$(window).resize(function () {
		waitForFinalEvent(function () {
			initFacts();
			initCaseStudyHeight();
			// initTeamSlider();
			initFaqSlider();
			initHomeRibbonsScroll();
			initCareerSlider();
		}, 500, "windowResize");
	});
}

function detectBreakpoint(bp) {
	if ($(window).width() <= 450) {
		if (bp === 'ms') {
			return true;
		}
	}
	if ($(window).width() <= 992) {
		if (bp === 'md') {
			return true;
		}
	}
	if ($(window).width() >= 768 && $(window).width() < 1100) {
		if (bp === 'customtablet') {
			return true;
		}
	}
	return false;
}

/* scroll to anchor directly on page load */
function initAnchorScroll() {
	// void some browsers issue
	if (window.location.hash) {
		window.setTimeout(function () {
			window.scroll(0, 0);
		}, 1);
	}

	var hashLink = window.location.hash;
	var paddingTop = parseFloat($(hashLink).css('padding-top'), 2);
	var scrollOffsetTop = 0;
	if (paddingTop < 130) {
		scrollOffsetTop = 100;
	}
	if (hashLink == '#contact-us') {
		scrollOffsetTop = 70;
	}


	if (hashLink.length && $(hashLink).length) {
		$(window).on('load', function () {
			setTimeout(function () {
				$(window).scrollTop($(hashLink).offset().top - scrollOffsetTop);
			}, 250);
		});
	}
}

function initSmoothAnchorScroll() {
	$('a[href^="/#"]').each(function () {
		$(this).attr('href', $(this).attr('href').substr(1));
	});
	// don't do it for bs collapse elements
	$(document).on('click', 'a[href^="#"]:not(.summary)', function (event) {
		event.preventDefault();
		if ($($.attr(this, 'href')).length != 0) {
			$('html, body').animate({
				scrollTop: $($.attr(this, 'href')).offset().top - 150
			}, 500);
		}
	});
}

function initSmoothAnchorScrollContact() {
	$('a[href*="#contact-us"]').on('click', function (e) {
		e.preventDefault();
		var target = this.hash;
		var $target = $(target);
		$('html, body').stop().animate({
			'scrollTop': $target.offset().top
		}, 900, 'swing', function () {
			window.location.hash = target;
		});
	});
}


/* Section 1 */

function initSlider(landingpage) {
	let slider;
	var slidesToShowXL;
	var slidesToShowL;
	var leftSliderArrow;
	var rightSliderArrow;
	var bp;

	if (landingpage == 'ipconsulting') {
		slider = $('.dcsection1__slider');
		leftSliderArrow = $('.dcsection1__arrowleft');
		rightSliderArrow = $('.dcsection1__arrowright');
	} else if (landingpage == 'associates') {
		slider = $('.acsection1__slider');
		leftSliderArrow = $('.acsection1__arrowleft');
		rightSliderArrow = $('.acsection1__arrowright');
	}
	if (slider.hasClass("slides_count_4")) {
		slidesToShowXL = 4;
		slidesToShowL = 2;
		bp = 1240;
	} else if (slider.hasClass("slides_count_5")) {
		slidesToShowXL = 5;
		slidesToShowL = 3;
		bp = 1500;
	}

	if (slider) {
		slider.slick({
			slidesToShow: 4,
			slidesToScroll: 1,
			infinite: false,
			dots: false,
			arrows: true,
			prevArrow: leftSliderArrow,
			nextArrow: rightSliderArrow,
			adaptiveHeight: true,
			focusOnSelect: true,
			responsive: [{
				breakpoint: bp,
				settings: {
					slidesToShow: slidesToShowL,
					slidesToScroll: 1
				}
			},
				{
					breakpoint: 1110,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}
			]
		});


		// slider.slick('slickGoTo', 2);
		$('.dcsection1__slidelink, .acsection1__slidelink, .dcsection11__servicelink').click(function () {
			$('html, body').animate({
				scrollTop: $('.dcsection3 .service_details').offset().top - 170
			}, 500);
			let id = $(this).data('id');

			$('.service_cards[data-cycle="' + id + '"]').click();


			/* does not work anymore /unclear */
			// switch (id) {
			// 	case 1:
			// 		$('.service_cards[data-cycle="' + id + '"]').click();
			// 		$('.service_cards[data-detail="2"]').click();
			// 		$('.service_cards[data-detail="5"]').click();
			// 		$('.service_cards[data-detail="7"]').click();
			// 		$('.detail_box[data-info="2"]').click();
			// 		$('.detail_box[data-info="13"]').click();
			// 		break;
			// 	case 2:
			// 		$('.service_cards[data-detail="3"]').click();
			// 		$('.service_cards[data-detail="6"]').click();
			// 		$('.service_cards[data-detail="8"]').click();
			// 		$('.detail_box[data-info="5"]').click();
			// 		$('.detail_box[data-info="16"]').click();
			// 		break;
			// 	case 3:
			// 		$('.service_cards[data-detail="3"]').click();
			// 		$('.service_cards[data-detail="6"]').click();
			// 		$('.service_cards[data-detail="9"]').click();
			// 		$('.detail_box[data-info="6"]').click();
			// 		$('.detail_box[data-info="17"]').click();
			// 		break;
			// 	case 4:
			// 		$('.service_cards[data-detail="2"]').click();
			// 		$('.service_cards[data-detail="5"]').click();
			// 		$('.service_cards[data-detail="10"]').click();
			// 		$('.detail_box[data-info="3"]').click();
			// 		$('.detail_box[data-info="14"]').click();
			// 		break;
			// }

			return false;
		});

		var acsectionCardHovered = false;
		var $me;
		$('.acsection1__slider .acsection1__slide .acsection1__card').hover(function (e) {
			$me = $(this);
			$me.parent().addClass('js_hovered');
			if ($me.parent().hasClass('slick-active')) {
				acsectionCardHovered = true;
				$me.parents('.acsection1__slider').siblings('.acsection1__arrows').fadeOut();
			}
		}, function () {
			$me.parent().removeClass('js_hovered');
			if ($me.parent().hasClass('slick-active')) {

				acsectionCardHovered = false;
				window.setTimeout(function () {

					if (!acsectionCardHovered) {
						$me.parents('.acsection1__slider').siblings('.acsection1__arrows').fadeIn("slow");
					}
				}, 350);

			}
		});

		var mobileClickCount = 0;
		// make whole card clickable on desktop
		$('.acsection1__slider .acsection1__slide').on('click', function () {
			mobileClickCount++;
			var $that = $(this);
			if ($that.hasClass('js_hovered')) {
				if ($(window).width() > 1099) {
					$that.find('.acsection1__slidelink a')[0].click();
				} else {
					if (mobileClickCount > 1) {
						$that.find('.acsection1__slidelink a')[0].click();
					}
				}

			}
		});

	}
}

function initLogoSlider() {
	let slider = $('.acsection1__logobanner');

	if (slider) {
		slider.slick({
			slidesToShow: 7,
			slidesToScroll: 1,
			variableWidth: true,

			infinite: true,
			dots: false,
			arrows: false,
			adaptiveHeight: true,
			responsive: [{
				breakpoint: 3200,
				settings: {
					slidesToShow: 6,
					slidesToScroll: 3
				}
			},
				{
					breakpoint: 1490,
					settings: {
						slidesToShow: 6,
						slidesToScroll: 3
					}
				},
				{
					breakpoint: 1110,
					settings: {
						slidesToShow: 5,
						slidesToScroll: 2
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 4,
						slidesToScroll: 1
					}
				}
			]
		});
	}
}

/* Section 4 */

function initFacts() {
	if ($('.dcsection4').length) {
		var _initFacts = function () {
			initOverlayOpen('.dcsection4__videolink', 'video');
		};
		var _cmgrCheck = function () {
			if (cmgr.initialized) {
				_initFacts();
			} else {
				setTimeout(_cmgrCheck, 500);
			}
		};
		_cmgrCheck();

		$('.dcsection4__card').unbind().click(function () {
			var posx = ($(this).data('id') - 1.1) * $(this).outerWidth(true);
			$('.dcsection4__scrollouter').animate({
				scrollLeft: posx
			}, 'slow');
		});
	}
}


/* Section 5 */

function sheetSlider() {
	var sheetnext = 0;
	if (sheetto === sheetact) {
		return false;
	}
	if (sheetto > sheetact) {
		sheetnext = sheetact + 1;
		sheet1 = $('.dcsection5__casesheet[data-id="' + sheetact + '"]');
		sheet2 = $('.dcsection5__casesheet[data-id="' + sheetnext + '"]');
		sheet1.addClass('fadebottom');
		sheet2.removeClass('fadetop');
		sheetact++;
	}
	if (sheetto < sheetact) {
		sheetnext = sheetact - 1;
		sheet1 = $('.dcsection5__casesheet[data-id="' + sheetact + '"]');
		sheet2 = $('.dcsection5__casesheet[data-id="' + sheetnext + '"]');
		sheet1.addClass('fadetop');
		sheet2.removeClass('fadebottom');
		sheetact--;
	}
	if (sheetto === sheetact) {
		return false;
	}
	setTimeout(sheetSlider, 500);
}

function initCaseStudyHeight() {
	if ($('.dcsection5').length) {

		setTimeout(delayCaseStudyHeight, 1000);
		/* Mobile Tabnavi */

		$('.dcsection5__tabnavi li').click(function () {
			var mytab = $(this).data('tab');
			$('.dcsection5__tabnavi li').removeClass('selected');
			$('.dcsection5__tabnavi li[data-tab="' + mytab + '"]').addClass('selected');
			$('.dcsection5__sheettext').addClass('hidden');
			$('.dcsection5__sheettext[data-tab="' + mytab + '"]').removeClass('hidden');
		});

		$('.dcsection5__tabnavi li[data-tab="1"]').click();
	}
}

function initCaseStudyScrollbar() {
	if ($('.dcsection5').length) {
		$('.dcsection5__scrollarea').overlayScrollbars({
			className: "os-theme-thin-dark",
			scrollbars: {
				clickScrolling: true
			}
		});
	}
}

function delayCaseStudyHeight() {
	var casesheetheight = 0;
	$('.dcsection5__casesheet').each(function () {
		var height = $(this).outerHeight();
		if (height > casesheetheight) {
			casesheetheight = height;
		}
	});
	let distance = 300;
	if (detectBreakpoint('md') === true) {
		distance = 200;
	}
	/*
	if (detectBreakpoint('ms') === true) {
		distance = -400;
	}
	*/
	casesheetheight = casesheetheight + distance;
	$('.dcsection5').css('min-height', casesheetheight + 'px');
}

var sheetact = 1;
var sheetto = 1;

function initSheetSlider() {
	if ($('.dcsection5').length) {
		$('.dcsection5__casesheet:first-of-type').removeClass('fadetop');
		$('.dcsection5__casestudy:first-of-type').find('.dcsection5__card').addClass('selected');

		$('.dcsection5__casestudy').click(function () {
			var id = $(this).data('id');
			$('.dcsection5__card').removeClass('selected');
			$(this).find('.dcsection5__card').addClass('selected');
			sheetto = id;
			if (sheetto !== sheetact) {
				sheetSlider();
			}

			/* Scrolling with Click */

			var posx = ($(this).data('id') - 1.5) * $(this).outerWidth();
			$('.dcsection5__scrollarea').animate({
				scrollLeft: posx
			}, 'slow');
		});

	}
}

/* Section 6 */

function initTeamSlider() {
	if ($('.dcsection6').length) {
		$('.dcsection6').each(function () {
			$(this).find('.dcsection6__slider').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: true,
				dots: false,
				arrows: true,
				focusOnSelect: true,
				variableWidth: true,
				prevArrow: $(this).find('.dcsection6__arrowleft'),
				nextArrow: $(this).find('.dcsection6__arrowright')
			});
		});
	}
}

/* Section 7 */

function faqScrollOpacity() {
	return false;
	$('.dcsection7__card').each(function () {
		if (detectBreakpoint('md') === true) {
			opacity = 1
		} else {
			var toptop = 0;
			if ($('.os-content').length) {
				var toptop = $('.os-content').position().top;
			}
			var top = $(this).position().top + toptop;
			var opacity = 1;
			if (top < 80) {
				opacity = Math.min(Math.max((60 + top) / 140, 0), 1);
				$(this).css('opacity', opacity);
			} else if (top > 540) {
				opacity = Math.min(Math.max((680 - top) / 140, 0), 1);
			}
		}
		$(this).css('opacity', opacity);
	});
}

var faqslider;

function initFaqSlider() {
	if ($('.dcsection7').length) {
		if (detectBreakpoint('md') === true) {
			if (faqslider) {
				faqslider.destroy();
				faqslider = null;
			}
			$('.dcsection7__scrollarea').unbind();
			$('.dcsection7__card').unbind().click(function () {
				if ($(this).hasClass('selected')) {
					$('.dcsection7__card').removeClass('selected');
				} else {
					$('.dcsection7__card').removeClass('selected');
					$(this).addClass('selected');
				}
			});
			faqScrollOpacity();
		} else {
			if (!(faqslider)) {
				faqslider = $(".partial-scrollbar").overlayScrollbars({
					className: "os-theme-thin-dark",
					scrollbars: {
						clickScrolling: true
					},
					callbacks: {
						onScroll: function () {
							faqScrollOpacity();
						}
					}
				}).overlayScrollbars();
			}
			$('.dcsection7__scrollarea').unbind().scroll(function () {
				faqScrollOpacity();
			});
			$('.dcsection7__card').unbind().click(function () {
				if ($(this).hasClass('selected')) {
					$('.dcsection7__card').removeClass('selected');
				} else {
					$('.dcsection7__card').removeClass('selected');
					$(this).addClass('selected');
				}
			});
			faqScrollOpacity();
		}
		let faqheight = 0;
		$('.dcsection7__scrollarea').find('.dcsection7__card').each(function () {
			faqheight = faqheight + $(this).outerHeight(true);
		});
		if (faqheight < 700) {
			faqheight = faqheight + 50;
			$('.dcsection7__scrollarea').css('height', faqheight + 'px');
		}
		$('.dcsection7__seeall').unbind().click(function () {
			$(this).detach();
			$('.dcsection7__scrollarea').css('height', 'inherit');
		});

	}
}

var homeRibbons;

/* Home Ribbons Scroll */
function initHomeRibbonsScroll() {

	if ($('#homepage-assistance').length) {

		if (detectBreakpoint('customtablet') === true) {
			// init scroll
			homeRibbons = $('#homepage-assistance>.container').overlayScrollbars({
				className: "os-theme-thin-dark",
				scrollbars: {
					clickScrolling: true
				}
			}).overlayScrollbars();
		} else {
			// destroy scroll
			if (homeRibbons) {
				homeRibbons.destroy();
				homeRibbons = null;
			}
		}

	}

}

/* Section 8 Slider */

function initTestimonialSlider() {
	var slider = $('.dcsection8__slider');
	if (slider) {
		slider.slick({
			slidesToShow: 1,
			infinite: true,
			dots: true,
			arrows: false,
			focusOnSelect: true,
			centerMode: true,
			variableWidth: true,
			responsive: [{
				breakpoint: 1921,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					infinite: true,
					dots: true,
					arrows: false,
					centerMode: true,
					focusOnSelect: true,
					centerPadding: '300px',
					variableWidth: false,
				}
			},
				{
					breakpoint: 993,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						infinite: true,
						dots: true,
						arrows: false,
						centerMode: true,
						centerPadding: '20%',
						variableWidth: false,
					}
				},
				{
					breakpoint: 451,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						infinite: true,
						dots: true,
						arrows: false,
						centerMode: true,
						centerPadding: '30px',
						variableWidth: false,
					}
				}
			]
		});
	}
}

/* Section 9 */

function floatingLabels() {


	// custom scrollbar
	var $formContainer = $('.dcsection9__formcontainer');
	var customScrollbars;

	customScrollbars = $formContainer.overlayScrollbars({
		className: "os-theme-thin-dark",
		scrollbars: {
			clickScrolling: true
		},
		callbacks: {
			onScroll: function () {
				//				console.log("scrolling");
				// if ()
			}
		}
	}).overlayScrollbars();


	// window.setTimeout(function() {
	$('.hbspt-form form input[type="text"], .hbspt-form form input[type="email"], .hbspt-form form input[type="tel"], .hbspt-form form textarea').on('keyup keypress blur change click', function () {
		var $that = $(this);


		// custom error classes
		window.setTimeout(function () {
			if ($that.parents('.hs-form-field').find('.hs-error-msgs').length) {

				$that.parents('.hs-form-field').addClass('has_errors');
			} else {

				$that.parents('.hs-form-field').removeClass('has_errors');
			}
		}, 200);

	});

	$('.hbspt-form form input[type="checkbox"]').change(function () {
		var $me = $(this);

		window.setTimeout(function () {
			if ($me.parents('.hs-dependent-field').find('.hs-error-msgs').length) {

				$me.parents('.hs-dependent-field').addClass('has_errors');
			} else {

				$me.parents('.hs-dependent-field').removeClass('has_errors');
			}
		}, 150);
	});


	var $vexSelects = $('.hbspt-form form select');

	if ($vexSelects.length > 0) {
		$vexSelects.each(function () {
			var $that = $(this);
			$that.select2({});
			$that.on('change', function (e) {

				// $that.parents('.hs-fieldtype-select').addClass('floating');
				$that.prev('.select2-container').addClass('new_val');

				window.setTimeout(function () {
					if ($that.parents('.hs-dependent-field').find('.hs-error-msgs').length) {
						$that.parents('.hs-dependent-field').addClass('has_errors');
					} else {
						$that.parents('.hs-dependent-field').find('.hs-form-field').removeClass('has_errors');
					}
				}, 200);
			});
			$that.on('select2-close', function (e) {

			});
		});
	}

	var hubspotform = $('.hbspt-form');
	var $hubspotFormElement = hubspotform.find('form.hs-form');
	var $hubspotFormItems = $hubspotFormElement.find('.hs-form-field, .hs-dependent-field');
	// custom form submit to catch errors and display them styled
	$hubspotFormElement.submit(function (e) {
		e.preventDefault();

		$(this).unbind('submit').submit();

		window.setTimeout(function () {
			$hubspotFormItems.each(function (index, el) {
				if ($(this).find('.hs-error-msgs').length === 1) {
					$(this).addClass('has_errors');
				}
			});
		}, 300);
	});

	// }, 1200);

	// if ($(this).val().length > 0) {
	// 	$(this).parent().parent().find('label').first().addClass('floating');
	// } else {
	// 	$(this).parent().parent().find('label').first().removeClass('floating');
	// }
	// if ($(this).is(':focus')) {
	// 	$(this).parent().parent().find('label').first().addClass('floating');
	// }
	//
	// if ($(this).parents('.hs-form-field').find('.hs-error-msgs')) {
	// 	$(this).parents('fieldset').addClass('has_errors');
	// } else {
	// 	$(this).parents('.hs-form-field').removeClass('has_errors');
	// }
	// 	});
	// });
}

/* check if element is in viewport */
function isOnScreen(elem) {
	// if the element doesn't exist, abort
	if (elem.length == 0) {
		return;
	}
	var $window = jQuery(window);
	var viewport_top = $window.scrollTop();
	var viewport_height = $window.height();
	var viewport_bottom = viewport_top + viewport_height;
	var $elem = jQuery(elem);
	var top = $elem.offset().top;
	var height = $elem.height();
	var bottom = top + height;

	return (top >= viewport_top && top < viewport_bottom) ||
		(bottom > viewport_top && bottom <= viewport_bottom) ||
		(height > viewport_height && top <= viewport_top && bottom >= viewport_bottom);
}

var submissioncheck = 0;

function checkForSubmitted() {
	//	var hubspotform = $('.hbspt-form');
	if ($('.dcsection9 .submitted-message').length > 0) {
		$('.dcsection9.bs4').addClass('submitted');
		$('.dcsection9__submitted').detach().prependTo($('.dcsection9 .submitted-message').parent());
		$('.dcsection9__formcontainer h3').detach();
		$('.submitted-message').detach();
		$('.dcsection9__backbutton').click(function () {
			location.reload();
			$('.dcsection9.bs4').removeClass('submitted');
		});
		clearInterval(submissioncheck);
	}
}

function initHubspotForm() {

	var formIsReady = false;

	var hubspotform = $('.dcsection9~.hbspt-form');

	if (hubspotform.length > 0) {
		hubspotform.detach().prependTo('.dcsection9__hubspotform');
	}

	// on form ready
	window.addEventListener("message", function (event) {
		if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormReady') {

			if (!formIsReady) {
				$('.dcsection9__formcontainer').overlayScrollbars({});

				// check for required fields and add info text to modal footer
				var requiredFieldCount = $('.dcsection9__hubspotform form.hs-form .hs-form-field .hs-form-required').length;
				if (requiredFieldCount >= 1) {
					var $submitArea = $('.dcsection9__hubspotform form.hs-form .hs_submit .actions');
					if (!$submitArea.find('.required_info').length) {
						let requiredFieldTranslations = {
							'en': 'Required field',
							'de': 'Pflichtfeld',
							'fr': 'Champ obligatoire',
							'ja': '必須項目',
							'zh': '必填栏位',
							'tw': '必填欄位',
							'it': 'Campo obbligatorio',
						};
						$submitArea.prepend('<p class="required_info">' + (requiredFieldTranslations[$('html').attr('lang')]) + '</p>');
					}
				}

				var $hubspotform = $('.dcsection9 .hs-form');
				var $form;
				var $hubspotFormItems;
				var submissioncheck = 0;

				// custom form submit to catch errors and display them styled
				$hubspotform.each(function () {
					$form = $(this);
					$hubspotFormItems = $form.find('.hs-form-field, .hs-dependent-field');

					// on change of form items check for errors classes - and remove custom err classes if no other are found
					$hubspotFormItems.on('change', function () {
						var $item = $(this);
						window.setTimeout(function () {
							$hubspotFormItems.each(function (index, el) {

								if ($(this).find('.hs-error-msgs').length === 1) {
									$(this).addClass('has_errors');
								} else {
									$(this).removeClass('has_errors');
								}
							});
						}, 300);
					});

					$form.submit(function (e) {
						e.preventDefault();

						$(this).unbind('submit').submit();
						window.setTimeout(function () {
							$hubspotFormItems.each(function (index, el) {
								if ($(this).find('.hs-error-msgs').length === 1) {
									$(this).addClass('has_errors');
								}
							});
						}, 300);
					});

				});


				var customizeSelectLists = function () {
					var $dcsection9selects = $('.dcsection9 select');
					if ($dcsection9selects.length > 0) {
						$dcsection9selects.each(function () {
							var $that = $(this);
							$(this).select2({});
							$(this).on('change', function (e) {
								$that.parents('.hs-fieldtype-select').addClass('new_val');
								$dcsection9selects.prev('.select2-container').addClass('new_val');
							});
						});
					}
				};
				customizeSelectLists();

				// Re-run select-customization on change of dependent field
				var $dependentFields = $('.dcsection9 .hs-dependent-field');
				$dependentFields.on('change', function () {
					var $me = $(this);
					customizeSelectLists();
				});

				submissioncheck = setInterval(checkForSubmitted, 1300);

				formIsReady = true;
			}
		}
	});

	$('.dcsection9__benefit').click(function () {
		$('.dcsection9__benefit').removeClass('active');
		$(this).addClass('active');
		var dataid = $(this).data('id');
		$('.dcsection9__mobilebenefittext').removeClass('active');
		$('.dcsection9__mobilebenefittext[data-id="' + dataid + '"]').addClass('active');
	});

}

/* Section 10 */

function initCareerSlider() {
	if ($('.dcsection10').length) {
		$('.dcsection10').each(function () {
			$(this).find('.dcsection10__slider').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: false,
				dots: false,
				arrows: true,
				focusOnSelect: true,
				variableWidth: true,
				prevArrow: $(this).find('.dcsection10__arrowleft'),
				nextArrow: $(this).find('.dcsection10__arrowright')
			});
		});
	}
}

/* Section 12 */

function initNavigation() {
	if ($('.dcsection12').length) {
		$('.dcheader__menu').click(function () {
			$('.dcsection12').addClass('open');
		});

		$('.dcsection12__close').click(function () {
			$('.dcsection12').removeClass('open');
		});

		$('.dcsection12__home').click(function () {
			$('html, body').animate({
				scrollTop: 0
			}, 500);
			$('.dcsection12').removeClass('open');
		});

		// add offset top to elements having smaller padding-top than 130
		$('.dcsection12__link').click(function () {
			let id = $(this).data('id');
			var paddingTop = parseFloat($('#' + id).css('padding-top'), 2);
			var scrollOffsetTop = 0;

			if (paddingTop < 130) {
				scrollOffsetTop = 100;
			}
			if (id == 'contact-us') {
				scrollOffsetTop = 70;
			}
			$('html, body').animate({
				scrollTop: $('#' + id).offset().top - scrollOffsetTop
			}, 500);
			$('.dcsection12').removeClass('open');
		});
	} else {
		$('.dcheader__menu').css('opacity', '0');
	}
}

/* Section 3 */

function serviceCardClick() {
	window.serviceCardClickInitialized = false;
	$('.service_cards').on('click touch', function () {


		let container = $(this).closest('.container');

		container.find('.service_cards').removeClass('active');

		container.find('.service_details').addClass('show');

		let cardId = $(this).data("hl");
		let detailId = $(this).data("detail");
		let detailTitle = $(this).data("detailtitle");

		if (window.serviceCardClickInitialized && detailTitle) {
			let params = new URLSearchParams(window.location.search);
			params.set('servicedetail', detailTitle);
			window.history.replaceState({}, '', window.location.pathname + '?' + params.toString());
		}

		if (cardId) {
			container.find('#' + cardId).addClass('active');
			container.find('#detail_' + cardId).removeClass('box-hidden');
			if ($(".detail-box-slick").hasClass('slick-initialized')) {
				$(".detail-box-slick").slick("refresh");
			}

		} else if (detailId) {
			$(this).addClass('active');

			container.find('.detail_boxes').removeClass('box-transition');
			container.find('.detail_boxes').addClass('box-hidden');
			container.find('.detail_boxes').removeClass('active');

			let boxToShow = $(this).closest('.container').find('#detail_' + detailId);

			boxToShow.addClass('active');
			boxToShow.addClass('box-transition');
			boxToShow.innerWidth();
			boxToShow.removeClass('box-hidden');
			if ($(".detail-box-slick").hasClass('slick-initialized')) {
				$(".detail-box-slick").slick("refresh");
			}

			boxToShow.one('webkitTransitionEnd oTransitionEnd msTransitionEnd transitionend', function () {
				boxToShow.removeClass('box-transition');
			});
		}

		container.find('#cards_overview').addClass('hide');
		container.find('#intro_body').addClass('hide');
		container.find('.details').addClass('show');
		container.find('.detail_box').removeClass('active');

		container.find('.details_to_box').addClass('details-hidden');

		if ($(".detail-box-slick").hasClass('slick-initialized')) {
			$('.detail-box-slick').slick('setPosition');
		}

		window.serviceCardClickInitialized = true;
	});

	// activate fist card programatically
	if ($('.dcsection3 .service_cards').length > 0) {
		//		$(window).on('load', function () {
		$('.dcsection3 .service_cards').eq(0).click();
		//		});
	}
}

function serviceDetailCardClick() {
	$('.detail_box').on('click touch', function () {
		//initServiceSliderIP();
		$(this).closest('.detail_boxes').find('.detail_box').removeClass('active');

		$(this).addClass('active');
		$(this).closest('.details').find('.details_to_box').addClass('details-hidden');

		let infoId = $(this).data("info");
		let info = $(this).closest('.details');

		if (infoId) {
			info.find('#info_' + infoId).addClass('active');
			info.find('#info_' + infoId).addClass('details-transition');
			info.find('#info_' + infoId).innerWidth();
			info.find('#info_' + infoId).removeClass('details-hidden');

			info.find('#info_' + infoId).one('webkitTransitionEnd oTransitionEnd msTransitionEnd transitionend', function () {
				info.find('#info_' + infoId).removeClass('details-transition');
			});
		}
	});
}

// feature removed
// function serviceBackArrow() {
// 	$('.arrow_back').on('click touch', function() {
// 		$(this).closest('.container').find('#cards_overview').removeClass('hide');
// 		$(this).closest('.container').find('#intro_body').removeClass('hide');
// 		$(this).closest('.container').find('.service_details').removeClass('show');
// 		$(this).closest('.container').find('.service_cards').removeClass('active');
// 		$(this).closest('.container').find('.card_icons').removeClass('active');
// 		$(this).closest('.container').find('.card_svg').removeClass('active');
// 		$(this).closest('.container').find('.cards_text').removeClass('active');
//
// 		$(this).closest('.container').find('.details').removeClass('show');
// 		$(this).closest('.container').find('.detail_boxes').addClass('box-hidden');
// 	});
// }

/* Associates Section 2*/
function initStatementSlider() {
	let slider = $('.acsection2__scrollinner');
	if (slider) {
		slider.slick({
			slidesToShow: 4,
			slidesToScroll: 1,

			infinite: false,
			dots: false,
			arrows: false,
			adaptiveHeight: true,
			responsive: [{
				breakpoint: 1490,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1
				}
			},
				{
					breakpoint: 1110,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 1
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}
			]
		});
	}
}

function initStatements() {
	let $acsection2 = $('.acsection2');

	if ($acsection2.length) {
		$acsection2.each(function () {
			var $module = $(this);

			if (!$module.hasClass('js_video_type_mp4')) {
				$module.addClass('js_cookie_active');
			}

			window.cmgr.onConsentForIdentifier('vimeo', function () {
				if ($module.hasClass('js_video_type_vimeo')) {
					$module.removeClass('js_cookie_active');
				}
			});
			window.cmgr.onConsentForIdentifier('youtube', function () {
				if ($module.hasClass('js_video_type_youtube')) {
					$module.removeClass('js_cookie_active');
				}
			});
		});

		$('.acsection2__card').click(function () {
			var posx = ($(this).data('id') - 1.5) * $(this).outerWidth();
			$('.acsection2__scrollouter').animate({
				scrollLeft: posx
			}, 'slow');
		});


		initOverlayOpen('.acsection2__videolink');
	}
}

/* AC Section 3 */

function acServiceFirstCardClick() {

	$('.acsection3__card_first').on('click touch', function () {
		let isMobile = window.matchMedia("only screen and (max-width: 992px)").matches;
		let cardID = $(this).data('card');
		let container = $(this).closest('.container');

		if (!isMobile) {
			// container.find('.desktop-cards').show();
			container.find('.headline_container').addClass('center-head');
			container.find('#initial').removeClass('col-lg-6');
			container.find('.cards-overview').removeClass('col-12');
			container.find('.cards-overview').removeClass('col-lg-6');
			container.find('.cards-overview').addClass('row');
			container.find('#cards_overview').addClass('col-12');
			container.find('#cards_overview').addClass('col-lg-4');
		}

		container.find('#intro_body').hide();
		container.find('#cards_overview').addClass('active');

		container.find('#' + cardID).addClass('show');
		container.find('#' + cardID).addClass('active');
		container.find('#second-screen').addClass('box-transition');
		container.find('#second-screen').innerWidth();
		container.find('#second-screen').removeClass('box-hidden');
		container.find('#second-screen').one('webkitTransitionEnd oTransitionEnd msTransitionEnd transitionend', function () {
			container.find('#second-screen').removeClass('box-transition');
		});
	});
}

function acServiceCardClick() {
	$('.acsection3__card_first').on('click touch', function () {
		let container = $(this).closest('.container');
		container.find('.acsection3__card').removeClass('active');
		container.find('.acsection3__details').removeClass('show');
		container.find('.acsection3__service-details').removeClass('show');
		container.find('.service-detail-cards').removeClass('active');

		let detailId = $(this).data("detail");
		container.find('#detail-' + detailId).addClass('show');
		$(this).addClass('active');
	});
}

function acServiceDetailCardClick() {
	$('.service-detail-cards').on('click touch', function () {
		let container = $(this).closest('.container');
		container.find('.service-detail-cards').removeClass('active');
		container.find('.acsection3__service-details').removeClass('show');

		let serviceDetailId = $(this).data("service_detail");
		container.find('#service-detail-' + serviceDetailId).addClass('show');
		$(this).addClass('active');
	});
}

function cardPosition() {
	$(window).resize(function (e) {
		let container = $('#first-screen');

		if ($('#cards_overview').hasClass('active')) {
			container.find('.headline_container').addClass('center-head');
			container.find('#initial').removeClass('col-lg-6');
			container.find('.cards-overview').removeClass('col-12');
			container.find('.cards-overview').removeClass('col-lg-6');
			container.find('.cards-overview').addClass('row');
			container.find('#cards_overview').addClass('col-12');
			container.find('#cards_overview').addClass('col-lg-4');
		}
	});
}

function serviceSlider() {
	$(window).on('resize orientationchange', function () {
		if (window.innerWidth < 992) {
			$('.headline_container').removeClass('center-head');
			if ($('#first-screen').hasClass('row')) {
				$('#first-screen').removeClass('row');
			}

			if (!$('.acsection3__service_cards').hasClass('slick-initialized')) {
				initServiceSlider();
			}

			if (!$('.cards-overview').hasClass('cards-overview-padding')) {
				$('.cards-overview').addClass('cards-overview-padding');
			}
		} else {

			if (!$('#first-screen').hasClass('row')) {
				$('#first-screen').addClass('row');
			}

			if ($('.acsection3__service_cards').hasClass('slick-initialized')) {
				$('.acsection3__service_cards').slick('unslick');
				$('.service-detail-slider').slick('unslick');
				$('.acsection3__button-container').slick('unslick');
			}
		}
	});
}

function initServiceSlider() {
	let slider = $('.acsection3__service_cards');
	let detailSlider = $('.service-detail-slider');
	let buttonSlider = $('.acsection3__button-container');
	let isMobile = window.matchMedia("only screen and (max-width: 992px)").matches;

	if (slider && isMobile) {
		slider.slick({
			slidesToShow: 4,
			slidesToScroll: 1,
			infinite: false,
			dots: false,
			arrows: false,
			responsive: [{
				breakpoint: 992,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1
				}
			},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1
					}
				},
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}
			]
		});
	}

	if (detailSlider && isMobile) {
		detailSlider.slick({
			slidesToShow: 4,
			slidesToScroll: 1,

			infinite: false,
			dots: false,
			arrows: false,
			adaptiveHeight: true,
			responsive: [{
				breakpoint: 992,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 1
				}
			},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 1
					}
				},
				{
					breakpoint: 640,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1
					}
				}
			]
		});
	}

	if (buttonSlider && isMobile) {
		buttonSlider.slick({
			slidesToShow: 4,
			slidesToScroll: 1,

			infinite: false,
			dots: false,
			arrows: false,
			adaptiveHeight: true,
			responsive: [{
				breakpoint: 992,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 1
				}
			},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 1
					}
				},
				{
					breakpoint: 640,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1
					}
				}
			]
		});
	}
}

/* AC Section 4 world map */

var countrylabel = $('.acsection4__countries .acsection4__pulldownlabel');
var citylabel = $('.acsection4__cities .acsection4__pulldownlabel');

function createPulldownMenus() {
	var recentcountries = [];
	$('.acsection4__office').each(function () {
		var country = $(this).data('country');
		var city = $(this).data('city');
		var id = $(this).data('id');
		if (recentcountries.indexOf(country) == -1) {
			$('.acsection4__countries .acsection4__pulldownentries').append('<div data-country="' + country + '">' + country + '</div>');
			recentcountries.push(country);
		}
		$('.acsection4__cities .acsection4__pulldownentries').append('<div data-country="' + country + '" data-city="' + city + '" data-id="' + id + '">' + city + '</div>');
	});
	//
	$('.acsection4__pulldown > div').click(function () {
		var pulldown = $(this);
		if (pulldown.hasClass('selected')) {
			$('.acsection4__pulldown > div').removeClass('selected');
		} else {
			$('.acsection4__pulldown > div').removeClass('selected');
			pulldown.addClass('selected');
		}
	});
	$('.acsection4__countries .acsection4__pulldownentries > div').click(function () {
		var country = $(this).data('country');
		var countrycount = 0;
		$('.acsection4__cities .acsection4__pulldownentries div').each(function () {
			var mycountry = $(this).data('country');
			if (country === mycountry) {
				$(this).removeClass('hidden');
				countrycount++;
			} else {
				$(this).addClass('hidden');
			}
		});
		countrylabel.html(country).addClass('selected');
		citylabel.html(citylabel.data('label')).removeClass('selected');
		if (countrycount === 1) {
			mycity = $('.acsection4__cities .acsection4__pulldownentries > div[data-country="' + country + '"]');
			var id = mycity.data('id');
			var city = mycity.data('city');
			selectOffice(id);
			citylabel.html(city).addClass('selected');
		}
	});
	$('.acsection4__cities .acsection4__pulldownentries > div').click(function () {
		var city = $(this).data('city');
		var id = $(this).data('id');
		selectOffice(id);
		citylabel.html(city).addClass('selected');
	});
}

function selectOffice(number) {

	closeTeamDetail();
	closeOfficeDetail();
	var thisoffice = $('.acsection4__office[data-id="' + number + '"]');
	$('.acsection4__office, .acsection4__mappoint').removeClass('selected');
	thisoffice.addClass('selected');
	$('.acsection4__mappoint[data-id="' + number + '"]').addClass('selected');
	//
	let mywidth = 180;
	let mycount = 4;
	if (detectBreakpoint('md') === true) {
		mywidth = 70;
		mycount = 2;
	}
	var posx = (number - mycount) * mywidth;
	$('.acsection4__scrollouter').animate({
		scrollLeft: posx
	}, 'fast');


	countrylabel.html(thisoffice.data('country')).addClass('selected');
	citylabel.html(thisoffice.data('city')).addClass('selected');

}

function openOfficeDetail(number) {
	if ($('.acsection4__detailwrapper').hasClass('selected')) {
		$('.acsection4__detailwrapper').removeClass('selected');
		setTimeout(function () {
			$('.acsection4__detailoffice').removeClass('selected');
			$('.acsection4__detailoffice[data-id="' + number + '"]').addClass('selected');
			$('.acsection4__detailwrapper').addClass('selected');
		}, 800);
	} else {
		$('.acsection4__detailoffice[data-id="' + number + '"]').addClass('selected');
		$('.acsection4__detailwrapper').addClass('selected');
	}
}

function openTeamDetail(number) {
	if ($('.acsection4__teamwrapper').hasClass('selected')) {
		$('.acsection4__teamwrapper').removeClass('selected');
		setTimeout(function () {
			$('.acsection4__detailteam').removeClass('selected');
			$('.acsection4__detailteam[data-teamid="' + number + '"]').addClass('selected');
			$('.acsection4__teamwrapper').addClass('selected');
		}, 800);
	} else {
		$('.acsection4__detailteam[data-teamid="' + number + '"]').addClass('selected');
		$('.acsection4__teamwrapper').addClass('selected');
	}
}

function closeOfficeDetail() {
	$('.acsection4__detailwrapper').removeClass('selected');
	setTimeout(function () {
		$('.acsection4__detailoffice').removeClass('selected');
	}, 800);
}

function closeTeamDetail() {
	$('.acsection4__teamwrapper').removeClass('selected');
	setTimeout(function () {
		$('.acsection4__detailteam').removeClass('selected');
	}, 800);
}

function initWorldMap() {
	if ($('.acsection4').length) {
		$('.acsection4__office').click(function () {
			var id = $(this).data('id');
			// selectOffice(id, true);
			closeTeamDetail();

			var thisoffice = $('.acsection4__office[data-id="' + id + '"]');
			$('.acsection4__office, .acsection4__mappoint').removeClass('selected');
			thisoffice.addClass('selected');
			$('.acsection4__mappoint[data-id="' + id + '"]').addClass('selected');
			//
			let mywidth = 180;
			let mycount = 4;
			if (detectBreakpoint('md') === true) {
				mywidth = 70;
				mycount = 2;
			}
			var posx = (id - mycount) * mywidth;
			$('.acsection4__scrollouter').animate({
				scrollLeft: posx
			}, 'slow');

			openOfficeDetail(id);
		});
		$('.acsection4__mappoint').click(function () {
			var id = $(this).data('id');
			selectOffice(id);
		});
		var officeswidth = 100;
		$('.acsection4__office').each(function () {
			officeswidth = officeswidth + $(this).outerWidth() + 30;
		});
		$('.acsection4__scrollinner').css('width', officeswidth).css('max-width', officeswidth);
		createPulldownMenus();
		//
		$('.acsection4__link').click(function (event) {
			event.stopPropagation();
			var id = $(this).data('id');
			openOfficeDetail(id);
		});
		$('.acsection4__detailclose').click(function () {
			closeOfficeDetail();
		});
		//
		$('.acsection4__detailofficememberbutton').click(function (event) {
			clearServicebox();
			event.stopPropagation();
			var id = $(this).data('teamid');
			openTeamDetail(id);
		});
		$('.acsection4__teamclose').click(function () {
			closeTeamDetail();
		});
		$('.acsection4__servicebox').click(function (e) {
			if ($(this).hasClass('selected')) {
				clearServicebox();
			} else {
				clearServicebox();
				$(this).addClass('selected');
			}
		});

		// drag control
		$('.acsection4__scrollouter').drags();

		// hide arrows if all offices fit to the screen width
		if ($('.acsection4__scrollouter').get(0).scrollWidth > $('.acsection4__scrollouter').innerWidth()) {
			$('.acsection4 .arrow_container').show();
		} else {
			$('.acsection4 .arrow_container').hide();
		}


		// arrows click
		let scrollOuter = $('.acsection4__scrollouter');
		let scrollInner = $('.acsection4__scrollinner');
		const scrollWidth = 70;
		let maxScrollLeft = scrollInner.width() - scrollOuter.width();

		if (scrollOuter.scrollLeft() == 0) {
			$('.acsection4__arrowleft').addClass('disabled');
		}

		$('.acsection4__arrowleft').click(function () {

			$('.acsection4__arrowright').removeClass('disabled');
			if (scrollOuter.scrollLeft() > 0) {
				$(this).removeClass('disabled');
				scrollOuter.animate({
					scrollLeft: scrollOuter.scrollLeft() - scrollWidth
				}, 'slow', function () {
					if (scrollOuter.scrollLeft() == 0) {
						$('.acsection4__arrowleft').addClass('disabled');
					}
				});

			} else if (scrollOuter.scrollLeft() == 0) {
				$(this).addClass('disabled');
			}
		});
		$('.acsection4__arrowright').click(function () {

			if (scrollOuter.scrollLeft() > maxScrollLeft) {
				$('.acsection4__arrowright').addClass('disabled');
			} else {
				$('.acsection4__arrowright').removeClass('disabled');
			}
			$('.acsection4__arrowleft').removeClass('disabled');
			scrollOuter.animate({
				scrollLeft: scrollOuter.scrollLeft() + scrollWidth
			}, 'fast');
		});
	}
}

function initOfficeLink() {
	if ($.urlParam('office')) {
		$('.acsection4__office[data-city="' + $.urlParam('office') + '"]').click();
		$('html, body').animate({
			scrollTop: $('.acsection4').offset().top
		}, 500);
	}
}


function clearServicebox() {
	$('.acsection4__servicebox').removeClass('selected');
}

/* IP Service Slider Mobile */
function serviceSliderIP() {
	if ($('.dcsection3').length) {
		$('.dcsection3__servicetab').click(function () {
			let id = $(this).data('id');
			$('.dcsection3__servicetab').removeClass('selected');
			$(this).addClass('selected');
			$('.dcsection3__servicetabcontent').removeClass('selected');
			$('.dcsection3__servicetabcontent[data-id="' + id + '"]').addClass('selected');
		});

		$('.dcsection3__servicetab').click(function () {
			let id = $(this).data('id');
			let mywidth = 130;
			let mycount = 1.5;
			var posx = (id - mycount) * mywidth;
			$('.dcsection3__servicetabs > div').animate({
				scrollLeft: posx
			}, 'slow');
		});
	}
	$(window).on('resize orientationchange', function () {
		waitForFinalEvent(function () {
			serviceSliderInitIP();
		}, 500, "serviceSlider");
	});


	if ($('.dcsection3.dcsection3_grid').length) {
		initOverlayOpen('.dcsection3__videolink');
	}
}

function serviceSliderInitIP() {
	let isMobile = window.matchMedia("only screen and (max-width: 1360px)").matches;
	if (isMobile) {
		if (!$('.dcsection3__service_cards').hasClass('slick-initialized')) {
			initServiceSliderIP();
		}

		if ($('#first-screen').hasClass('row')) {
			$('#first-screen').removeClass('row');
		}

		if ($('#cards').hasClass('col-4')) {
			$('#cards').removeClass('col-4').addClass('col-12');
		}

		if ($('.service_details').hasClass('row')) {
			$('.service_details').removeClass('row');
		}
		if ($('.detail_boxes').hasClass('col-4')) {
			$('.detail_boxes').removeClass('col-4').addClass('col-12');
		}

		if ($('.details_to_box').hasClass('col-4')) {
			$('.details_to_box').removeClass('col-4').addClass('col-12 no_padding');
		}

		if ($('.keyword-col').hasClass('col-9 col-xl-10')) {
			$('.keyword-col').removeClass('col-9 col-xl-10');
		}

	} else {
		if (!$('#first-screen').hasClass('row')) {
			$('#first-screen').addClass('row');
		}

		if (!$('#cards').hasClass('col-4')) {
			$('#cards').addClass('col-4').removeClass('col-12');
		}

		if (!$('.service_details').hasClass('row')) {
			$('.service_details').addClass('row');
		}
		if (!$('.detail_boxes').hasClass('col-4')) {
			$('.detail_boxes').addClass('col-4').removeClass('col-12');
		}

		if (!$('.details_to_box').hasClass('col-4')) {
			$('.details_to_box').addClass('col-4').removeClass('col-12 no_padding');
		}

		if (!$('.keyword-col').hasClass('col-9 col-xl-10')) {
			$('.keyword-col').addClass('col-9 col-xl-10');
		}

		if ($('.dcsection3').hasClass('dcsection3_grid')) {
			if ($('.dcsection3__service_cards').hasClass('slick-initialized')) {
				$('.dcsection3__service_cards').slick('unslick');
			}
			initServiceSliderIP();
		} else {
			if ($('.dcsection3__service_cards').hasClass('slick-initialized')) {
				$('.dcsection3__service_cards').slick('unslick');
			}
			if ($('.dcsection3 .detail-box-slick').hasClass('slick-initialized')) {
				$('.dcsection3 .detail-box-slick').slick('unslick');
			}
		}
	}


}

function initServiceSliderIP() {
	let $slider = $('.dcsection3__service_cards');
	let $detailSlider = $('.detail-box-slick');
	let isMobile = window.matchMedia("only screen and (max-width: 1360px)").matches;
	var isNewGridSlider = $detailSlider.parents('.dcsection3').hasClass('dcsection3_grid');

	if ($slider && isMobile) {
		$slider.on('init', function (event, slick) {
			// console.log("slider initialized");
		});
		if (!$slider.hasClass('slick-initialized')) {
			$slider.slick({
				slidesToShow: 4,
				slidesToScroll: 1,
				infinite: false,
				focusOnSelect: true,
				dots: false,
				arrows: false,
				centerPadding: '50px',
				responsive: [{
					breakpoint: 1360,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 1
					}
				},
					{
						breakpoint: 992,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 1
						}
					},
					{
						breakpoint: 592,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1
						}
					}
				]
			});
			$slider.on('beforeChange', function (event, slick, currentSlide) {

			});
			$slider.on('afterChange', function (event, slick) {
				if (isNewGridSlider) {
					//	$(this).find('.slick-current').trigger('click');

				}
			});
		}
	}

	var detailSliderOptions = {
		slidesToShow: 4,
		slidesToScroll: 1,
		infinite: false,
		dots: false,
		focusOnSelect: true,
		arrows: false,
		setPosition: true,
		adaptiveHeight: true,
		centerPadding: '50px',
		responsive: [{
			breakpoint: 1300,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 1
			}
		},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 630,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	};


	var slideCount;
	if ($detailSlider) {
		$detailSlider.on('init', function (event, slick) {

		});
		if (!$detailSlider.hasClass('slick-initialized')) {
			//console.log(test)
			$detailSlider.each(function () {
				var $individualSlider = $(this);

				// new slider, desktop + mobile
				if (isNewGridSlider) {
					detailSliderOptions.arrows = true;
					detailSliderOptions.slidesToShow = 3;
					detailSliderOptions.prevArrow = $individualSlider.parent('.outer_box').find($('.dcsection3__arrowleft'));
					detailSliderOptions.nextArrow = $individualSlider.parent('.outer_box').find($('.dcsection3__arrowright'));
				}

				// init each
				$individualSlider.slick(detailSliderOptions);
			});
		}
	}
}

/* Overlay & forms */

function initHubspotVexDlg() {
	$('.js_hubspotdlg').on('click', function () {
		let hubspotid = $(this).data('hubspotid');
		let label = $(this).html();
		openVexDialog(label, '', '2093377', hubspotid);
	});
};

function initOverlay() {
	/* Open Hubspot contact forms in overlay */
	$('.openhubspotform').click(function () {

		let hubspotid = $(this).data('hubspotid');
		let mediaid = $(this).data('mediaid');
		let label = $(this).html();

		openVexDialog(label, '', '2093377', hubspotid, null, null, null, mediaid);

		$('html').addClass('noscroll');
		setTimeout(overlayFloatingLabels, 1000);
		overlaysubmissioncheck = setInterval(overlayCheckForSubmitted, 1000);
	});

}

function clickGetInTouchButton() {
	/* check if popup shall open immediately */
	let getintouchButton = document.getElementById('getintouchbutton');
	if (getintouchButton && (new URLSearchParams(window.location.search)).has('getintouch')) {
		getintouchButton.click();
	}
}

// deprecated: replaced by vex-modal logic
function initOverlay2() {
	/* Open Hubspot contact forms in overlay */
	$('.openhubspotform').click(function () {
		let hubspotid = $(this).data('hubspotid');
		let label = $(this).html();
		$('.overlay__box').html('');
		hbspt.forms.create({
			portalId: "2093377",
			formId: hubspotid,
			target: ".overlay__box",
			onFormReady: function ($form) {
				$('.overlay__header').append('<div class="overlay__close"></div>');
				$('.overlay__close').unbind().click(function () {
					$('.overlay').removeClass('show');
					$('html').removeClass('noscroll');
					$formContainer.overlayScrollbars().destroy();
					// setTimeout(function() {
					// ticket 38031
						$('.overlay__box').html('');
						$('.overlay__header').html('');
					// }, 1000);
				});

				// custom scrollbar
				var $formContainer = $('.overlay__box');
				var customScrollbars;

				customScrollbars = $formContainer.overlayScrollbars({
					className: "os-theme-thin-dark",
					scrollbars: {
						clickScrolling: true
					}
				}).overlayScrollbars();
			}
		});
		$('.overlay__header').html(label);
		$('.overlay').addClass('show');
		$('html').addClass('noscroll');
		setTimeout(overlayFloatingLabels, 1000);
		overlaysubmissioncheck = setInterval(overlayCheckForSubmitted, 1000);
	});
}

//
// function isOnScreen(elem) {
// 	// if the element doesn't exist, abort
// 	if (elem.length == 0) {
// 		return;
// 	}
// 	var $window = jQuery(window)
// 	var viewport_top = $window.scrollTop()
// 	var viewport_height = $window.height()
// 	var viewport_bottom = viewport_top + viewport_height
// 	var $elem = jQuery(elem)
// 	var top = $elem.offset().top
// 	var height = $elem.height()
// 	var bottom = top + height
//
// 	return (top >= viewport_top && top < viewport_bottom) ||
// 		(bottom > viewport_top && bottom <= viewport_bottom) ||
// 		(height > viewport_height && top <= viewport_top && bottom >= viewport_bottom)
// }

/* New Overlay with vex-dialog */
function initOverlayOpen(classname, overlayClassname) {

	$(classname).unbind('click').click(function () {
		let header = $(this).data('header');
		let content = $(this).data('code');
		let classNames = "dialog_small";
		if (overlayClassname) {
			classNames = classNames + ' ' + overlayClassname;
		}

		content = $(content).html();
		openVexDialog(header, content, null, null, null, null, classNames);
	});
}

/* DEPRECATED: USE initOverlayOpen() with vex-dialog instead of overlay */
function initOverlayOpen2(classname, overlayClassname) {
	$(classname).click(function () {
		let header = $(this).data('header');
		let code = $(this).data('code');
		$('.overlay__box').html('');
		if (overlayClassname) {
			$('.overlay__box').addClass(overlayClassname);
		}
		$(code).clone().appendTo('.overlay__box');
		$('.overlay__header').html(header);
		$('.overlay__header').append('<div class="overlay__close"></div>');
		$('.overlay').addClass('show');
		$('.overlay__close').unbind().click(function () {
			$('.overlay').removeClass('show');
			$('.overlay__box').removeClass(overlayClassname);
			setTimeout(function () {
				$('.overlay__box').html('');
				$('.overlay__header').html('');
			}, 1000);
		});
	});
}

function overlayFloatingLabels() {


	$('.overlay form input[type="text"], .overlay form input[type="email"], .overlay form input[type="tel"], .overlay form textarea').on('keyup keypress blur change click', function () {
		var $that = $(this);

		// custom error classes
		window.setTimeout(function () {
			if ($that.parents('.hs-form-field').find('.hs-error-msgs').length) {

				$that.parents('.hs-form-field').addClass('has_errors');
			} else {

				$that.parents('.hs-form-field').removeClass('has_errors');
			}
		}, 200);

	});

	$('.overlay form input[type="checkbox"]').change(function () {
		var $me = $(this);

		window.setTimeout(function () {
			if ($me.parents('.hs-dependent-field').find('.hs-error-msgs').length) {

				$me.parents('.hs-dependent-field').addClass('has_errors');
			} else {

				$me.parents('.hs-dependent-field').removeClass('has_errors');
			}
		}, 150);
	});


	var $overlaySelects = $('.overlay form select');

	if ($overlaySelects.length > 0) {
		$overlaySelects.each(function () {
			var $that = $(this);
			$that.select2({});
			$that.on('change', function (e) {
				// $that.parents('.hs-fieldtype-select').addClass('floating');
				$vexSelects.prev('.select2-container').addClass('new_val');

				window.setTimeout(function () {
					if ($that.parents('.hs-dependent-field').find('.hs-error-msgs').length) {
						$that.parents('.hs-dependent-field').addClass('has_errors');
					} else {
						$that.parents('.hs-dependent-field').find('.hs-form-field').removeClass('has_errors');
					}
				}, 200);
			});
			$that.on('select2-close', function (e) {

			});
		});
	}

	var $overlay = $('.overlay');
	var $hubspotFormElement = $overlay.find('form.hs-form');
	var $hubspotFormItems = $hubspotFormElement.find('.hs-form-field, .hs-dependent-field');
	// custom form submit to catch errors and display them styled
	$hubspotFormElement.submit(function (e) {
		e.preventDefault();

		$(this).unbind('submit').submit();

		window.setTimeout(function () {
			$hubspotFormItems.each(function (index, el) {
				if ($(this).find('.hs-error-msgs').length === 1) {
					$(this).addClass('has_errors');
				}
			});
		}, 300);
	});

}

var overlaysubmissioncheck = 0;

function overlayCheckForSubmitted() {
	var hubspotform = $('.overlay .hbspt-form');
	if ($('.overlay__box .submitted-message').length > 0) {
		$('.overlay__submitted').prependTo('.overlay__box');
		$('.overlay__backbutton').click(function () {
			location.reload();
		});
		clearInterval(submissioncheck);
	}
}


$.urlParam = function (paramName) {
	var check = '' + paramName;
	var url = window.location.href;
	if (url.search(check) >= 0) {
		return url.substring(url.search(check)).split('&')[0].split('=')[1];
	}
};

function initScrollToService() {
	var topoffset = 170;
	if ($.urlParam('servicedetail')) {
		if (!$('.dcsection3').hasClass('dcsection3_grid')) {
			$('.service_cards[data-detailtitle="' + $.urlParam('servicedetail') + '"]').click();

			if ($.urlParam('serviceinfo')) {
				$('.detail_box[data-infotitle="' + $.urlParam('serviceinfo') + '"]').click();
			}
			$('html, body').animate({
				scrollTop: $('.dcsection3 .service_details').offset().top - topoffset
			}, 500);
		}

		// Grid modul
		if ($('.dcsection3').hasClass('dcsection3_grid')) {
			$('.service_cards[data-detailtitle="' + $.urlParam('servicedetail') + '"]').click();
			$('html, body').animate({
				scrollTop: $('.dcsection3').offset().top
			}, 500);
		}
	}
}

function initScrollToCaseStudy() {
	if ($.urlParam('casestudy')) {
		$('.dcsection5__casestudy[data-url-label="' + $.urlParam('casestudy') + '"]').click();
		$('html, body').animate({
			scrollTop: $('.dcsection5').offset().top
		}, 500);
	}
}


function initTopBarScrollBehaviour() {
	var isActive = true;
	var $window = $(window);
	var $topbar = $('#header-main-top');
	var $trigger = $('#homepage-assistance');
	if ($trigger.length === 0) {
		$trigger = $('#content section:first-of-type');
	}

	var scrollHandler = function () {
		if ($window.scrollTop() > $trigger.offset().top + $trigger.height()) {
			if (isActive === true) {
				$topbar.css('min-height', 'unset');
				$topbar.toggleClass('scrollhide', true);
				$topbar.stop(true, false).slideUp();
			}
			isActive = false;
		} else {
			if (isActive === false) {
				$topbar.toggleClass('scrollhide', false);
				$topbar.stop(true, false).slideDown(function () {
					$topbar.css('min-height', '');
				});
			}
			isActive = true;
		}
	};

	if ($trigger.length > 0) {
		scrollHandler();
		window.addEventListener('scroll', scrollHandler, {
			passive: true
		});
	}
}

function initNavigationScrollBehaviour() {
	var $window = $(window);
	var $nav = $('#header-main-container');
	var $searchFlyout = $('.js_search_container_flyout');
	var $header = $('#header-main-top');
	if ($nav.length === 0) {
		$nav = $('#header-main-top + .dcheader');
	}

	var scrollHandler = function () {
		if ($window.scrollTop() > 0) {
			$searchFlyout.addClass('no_main_header');
			$header.addClass('scrolling');
			$nav.toggleClass('small_header', true);
		} else {
			$nav.toggleClass('small_header', false);
			$header.removeClass('scrolling');
			$searchFlyout.removeClass('no_main_header');
		}
	};

	scrollHandler();
	window.addEventListener('scroll', scrollHandler, {
		passive: true
	});
}

(function ($) {
	$.fn.drags = function (opt) {

		opt = $.extend({
			handle: "",
			cursor: "move",
			draggableClass: "draggable",
			activeHandleClass: "active-handle"
		}, opt);

		var $selected = null;
		var $elements = (opt.handle === "") ? this : this.find(opt.handle);

		$elements.css('cursor', opt.cursor).on("mousedown", function (e) {
			if (opt.handle === "") {
				$selected = $(this);
				$selected.addClass(opt.draggableClass);
			} else {
				$selected = $(this).parent();
				$selected.addClass(opt.draggableClass).find(opt.handle).addClass(opt.activeHandleClass);
			}
			var drg_w = $selected.outerWidth(),
				pos_x = $selected.offset().left + drg_w - e.pageX;
			var initialScrollleft = $selected.scrollLeft();
			var scrollFactor;
			$(document).on("mousemove", function (e) {
				scrollFactor = e.pageX + pos_x - drg_w;
				scrollFactor = initialScrollleft - scrollFactor;

				$selected.scrollLeft(scrollFactor);

			}).on("mouseup", function () {
				$(this).off("mousemove"); // Unbind events from document
				if ($selected !== null) {
					$selected.removeClass(opt.draggableClass);
					$selected = null;
				}
			});
			e.preventDefault(); // disable selection
		}).on("mouseup", function () {
			if (opt.handle === "") {
				$selected.removeClass(opt.draggableClass);
			} else {
				$selected.removeClass(opt.draggableClass)
					.find(opt.handle).removeClass(opt.activeHandleClass);
			}
			$selected = null;
		});

		return this;

	};
})(jQuery);

function initImgScroll() {
	if ($('.scroll_image').length > 0) {
		$(window).scroll(function () {
			$('.stage_media').toggleClass('scrolled', $(this).scrollTop() > 50);
		});
	}
}

function initStickyNav() {
	let ribbonNav = $('.ribbon_nav');
	if (ribbonNav.length > 0) {
		let ribbonNavTop = ribbonNav.offset().top;
		$(window).on('resize scroll', function () {
			const currentScroll = $(this).scrollTop();
			if ($(this).scrollTop() > ribbonNavTop) {
				$('.brand_page').addClass('sticky');
			} else {
				$('.brand_page').removeClass('sticky');
			}
		});
		$(window).trigger('resize');
	}
}